import { exists } from '@engine/lib/utility/exists';
var ERROR_ANIMATION_TIME = 1000;
var MSG_ANIMATION_TIME = 3000;

function AssignedEntity(options) {
  var _this = this;

  var fadeTimeout = null;
  var container = $(options.container);
  var containerId = options.container;
  var message = $(options.message);
  var form = $(options.form);

  var clearMessage = function clearMessage() {
    message.removeClass('alert-success-light alert-danger-light').html('');
  };

  _this.getForm = function () {
    return form;
  };

  _this.getContainerId = function () {
    return containerId;
  };

  _this.getContainer = function () {
    return container;
  };

  _this.getText = function (action) {
    return message.data('success-' + action + '-message');
  };

  _this.updateMessage = function (text, type) {
    message.html(text).removeClass('alert-danger-light').addClass('alert-success-light');

    if (type === 'error') {
      message.removeClass('alert-success-light').addClass('alert-danger-light');
    }

    clearTimeout(fadeTimeout);
    fadeTimeout = setTimeout(clearMessage, MSG_ANIMATION_TIME);
  };

  _this.updateContainer = function (data) {
    container.html($(data).find(containerId).html());
  };

  _this.loaderHide = function () {
    container.find('.table-loader').addClass('hidden');
  };

  _this.loaderShow = function () {
    container.find('.table-loader').removeClass('hidden');
    clearMessage();
  };
}

AssignedEntity.prototype.listenForCreate = function () {
  var _this = this;

  _this.getForm().on('submit', function (e) {
    e.preventDefault();
    $.ajax({
      url: $(this).attr('action'),
      method: 'POST',
      data: $(this).serialize(),
      beforeSend: _this.loaderShow
    }).done(function (data) {
      _this.updateContainer(data);

      var errorMessage = $(data).find('[id$=_error_message]');

      if (exists(errorMessage)) {
        _this.updateMessage(errorMessage.text(), 'error');

        var errorRow = _this.getContainer().find('tr:contains(' + errorMessage.data('code') + ')').addClass('highlight-error');

        setTimeout(function () {
          errorRow.removeClass('highlight-error');
        }, ERROR_ANIMATION_TIME);
      } else {
        _this.updateMessage(_this.getText('create'));
      }
    }).always(_this.loaderHide);
  });

  return _this;
};

AssignedEntity.prototype.listenForDestroy = function () {
  var _this = this;

  $(document).on('click', _this.getContainerId() + ' a', function (e) {
    e.preventDefault();
    $.ajax({
      url: $(this).attr('href'),
      method: 'DELETE',
      beforeSend: _this.loaderShow
    }).done(function (data) {
      _this.updateContainer(data);

      _this.updateMessage(_this.getText('delete'));
    }).always(_this.loaderHide);
  });
  return _this;
};

export { AssignedEntity };